import "../App.css";

import React from "react";
import { inject, observer } from "mobx-react";
import { Loading } from "../Components/Loading";
import Footer from "../Components/Layout/Footer";
import StepContent from "../Components/Layout/StepContent";
import CompleteStep from "../Components/CompleteStep";
import DependencyPopup from "../Components/DependencyPopup";
import DependantPopup from "../Components/DependantPopup";

@inject("AppStore")
@observer
class App extends React.Component {
  store = this.props.AppStore;

  componentDidMount() {
    const { slug, lang, number } = this.props.match.params;

    this.store.page.lang = lang || "en";
    this.store.page.suffix =
      this.store.page.lang === "en" ? "" : `_${this.store.page.lang}`;

    this.store.getLocation("default");
    this.store.loadConfig();

    // get path
    this.store.init(slug, number);
    this.store.sendModelUpdate();
  }

  render() {
    const { page } = this.store;

    if (page.loading) return <Loading />;

    return (
      <>
        <div className="content">
          {page.completeStep !== page.stepIndex ? (
            <StepContent store={this.store} />
          ) : (
            <div
              className={`step-content-inner ${"flex animate__animated animate__fadeIn"}`}
              data-title="Complete"
            >
              <CompleteStep store={this.store} />
            </div>
          )}
        </div>

        {page.completeStep !== page.stepIndex && <Footer store={this.store} />}

        <DependencyPopup />
        <DependantPopup />
      </>
    );
  }
}

export default App;
